import React from 'react';
import { cn } from '@/utils';

type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => {
  return (
    <textarea
      ref={ref}
      className={cn(
        'block w-full px-4 py-2 text-sm border rounded-md transition focus:outline-none',
        'border-gray-300 focus:border-blue-500 focus:ring-1 focus:ring-blue-500',
        className,
      )}
      {...props}
    />
  );
});
